import { Feature } from "ol";
import { Geometry, LineString } from "ol/geom";
import Style from "ol/style/Style";
import BaseFeature from "./base.feature"
import IDeviceStore from "@/models/modelStore/IDeviceStore";
import { fromLonLat } from "ol/proj";
import Stroke from "ol/style/Stroke";
import { ColorsRasterEnum } from "@/models/colors/colors-raster.enum";

export default class RasterFeature extends BaseFeature {

    device: IDeviceStore
    index: number
    constructor(device: IDeviceStore, index: number) {
        super();
        this.device = device
        this.index = index
    }

    getFeature(): Feature<Geometry> {
        return new Feature({
            geometry: new LineString(this.mapPositions()), //recoge las coordenadas de ubicacion
            type: 'device',
            device: this.device
        })
    }

    mapPositions() {
        return this.device.positions?.map(position => {
            return fromLonLat([position?.longitude || 0, position?.latitude || 0])
        }) || []
    }

    getColor(): string {
        const num = Object.keys(ColorsRasterEnum).length
        return Object.values(ColorsRasterEnum)[this.index % num]
    }

    getStyle(): Style {
        return new Style({
            stroke: new Stroke({
                color: this.getColor(),
                lineJoin: 'round',
                width: 6
            })
        })
    }
    isValid(): boolean {
        return true
    }

}